/**
 * The Latin letter a key stands for, whatever the keyboard layout, so a letter shortcut works on the Greek layout too:
 * there L types λ and C ψ (and Ctrl+Z gives ζ), so a key that types anything but a Latin letter falls back to its place
 * on the keyboard (KeyL → l). A Latin letter wins over the place, for layouts that move the letters. Lower case; any
 * other key (Space, the arrows, Delete, + and −) comes back as it is.
 */
export function letterKey(e: { key: string; code: string }): string {
  if (/^[a-z]$/i.test(e.key)) return e.key.toLowerCase();
  const place = /^Key([A-Z])$/.exec(e.code);
  return place && [...e.key].length === 1 ? place[1]!.toLowerCase() : e.key;
}
